import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AppEventService {
  
  private menuClickedSource = new Subject<void>();
  menuClicked$ = this.menuClickedSource.asObservable();

  notifyMenuClicked() {
    this.menuClickedSource.next();
  }
}
